/// <reference path="WebComponent.ts" />


namespace Sintra {

	// const WizardPageStyle = document.createElement("style");
	// WizardPageStyle.innerHTML = `
	// 	.wizard-page {
	// 		position: relative;
	// 		text-align: center;
	// 	}
	// 	.wizard-page > .primary-text-container {
	// 		display: flex;
	// 		flex-direction: row;
	// 		justify-content: center;
	// 		align-items: flex-start;
	// 	}
	// 	.wizard-page [template-part="primaryText"] {
	// 		text-align: center;
	// 		font-size: 36px;
	// 		line-height: 42px;
	// 		font-weight: 700;
	// 		color: #003165;
	// 		margin-left: 50px;
	// 		margin-right: 50px;
	// 	}
	// 	.wizard-page [template-part="pageContent"] {
	// 		display: flex;
	// 		flex-direction: row;
	// 		justify-content: center;
	// 		align-items: stretch;
	// 		margin-top: 30px;
	// 	}
	// 	.wizard-page [template-part="contentImage"] {
	// 		margin-right: 30px;
	// 	}
	// 	.wizard-page [template-part="contentHtml"] {
	// 		padding-top: 30px;
	// 		text-align: left;
	// 	}
	// 	.wizard-page [template-part="navigationButtons"] {
	// 		display: flex;
	// 		flex-direction: row;
	// 		justify-content: center;
	// 		margin-top: 30px;
	// 	}`;
	//document.head.appendChild(WizardPageStyle);


	const WizardPageTemplate = document.createElement("template");
	WizardPageTemplate.innerHTML = /*html*/ `
		<div class="primary-text-container">
			<div template-part="primaryText"></div>
		</div>
		<div template-part="pageContent">
			<img template-part="contentImage"/>
			<div template-part="contentHtml"></div>
		</div>
		<div template-part="navigationButtons">
		</div>
	`;

	export class WizardPage extends WebComponent {

		private _wizardControl: WizardControl;
		private _history: NavigationHistory;
		private _pageData: WizardPageData;

		private _primaryTextElement: HTMLElement;
		private _contentContainerElement: HTMLElement;
		private _contentHtmlElement: HTMLElement;
		private _contentImageElement: HTMLImageElement;
		private _footerElement: HTMLElement;
		private _footerTextElement: HTMLElement;
		private _navigationButtonsElement: HTMLElement;
		private _navigationButtons: Array<WizardNavButton>;
		private _navButtonTemplate: TemplateSource;
		private _hideHistoryButtons: boolean;

		private _btnNavigateBack: HTMLElement;
		private _btnNavigateNext: HTMLElement;

		private _orignalContentContainerDisplayStyle: string = "flex";

		private _isNavigating: boolean;

		constructor(wizardControl: WizardControl, history: NavigationHistory, templateSource?: TemplateSource) {
			super("div", templateSource || WizardPageTemplate);

			this._wizardControl = wizardControl;
			this._history = history;
			this.htmlElement.classList.add("wizard-page");

			wizardControl.htmlElement.addEventListener("end-navigate", (e) => {
				this._isNavigating = false;
			});
			history.addChangedHandler(this._onHistoryChanged.bind(this));
		}

		protected onApplyTemplate(templateRoot: HTMLElement) {

			this._navigationButtons = [];
			this._primaryTextElement = this.getTemplatePart("primaryText");
			this._contentContainerElement = this.getTemplatePart("pageContent");
			this._contentHtmlElement = this.getTemplatePart("contentHtml");
			this._contentImageElement = this.getTemplatePart("contentImage");
			this._footerElement = this.getTemplatePart("footer");
			this._footerTextElement = this.getTemplatePart("footerText");
			this._navigationButtonsElement = this.getTemplatePart("navigationButtons");

			this._btnNavigateBack = this.getTemplatePart("navigateBackButton");
			if (this._btnNavigateBack) {
				this._btnNavigateBack.addEventListener("click", this._onBackButtonClick.bind(this));
				this._setNavigateBackVisibility(false);
			}

			this._btnNavigateNext = this.getTemplatePart("navigateNextButton");
			if (this._btnNavigateNext) {
				this._btnNavigateNext.addEventListener("click", this._onNextButtonClick.bind(this));
				this._setNavigateNextVisibility(false);
			}

			if (this._pageData) {
				this._loadPageData();
			}
		}

		private _loadNavigationButtons(buttonsData: Array<WizardNavButtonData>) {
			for (const navBtn of buttonsData) {
				const button = new WizardNavButton();
				button.image = navBtn["image"];
				button.text = navBtn["text"];
				button.secondaryText = navBtn["secondaryText"];
				button.targetStep = navBtn["target"];
				button.complete = navBtn["complete"];
				button.appearance = navBtn["appearance"] || "default";
				if (this._navButtonTemplate) {
					button.template = this._navButtonTemplate;
				}
				const navBtnSetters = navBtn["setters"];
				if (navBtnSetters) {
					for (const k of Object.keys(navBtnSetters)) {
						const value = navBtnSetters[k];
						button.setters[k] = value;
					}
				}
				button.htmlElement.addEventListener("nav-click", this._onNavButtonClick.bind(this));

				this._navigationButtons.push(button);
				this._navigationButtonsElement.appendChild(button.htmlElement);
			}
		}


		private _loadPageData() {

			this.hideHistoryButtons = this._pageData["hideHistoryButtons"] || false;

			this._primaryTextElement.innerText = this._pageData["primaryText"];

			const contentHtml = this._pageData["contentHtml"];
			const contentImage = this._pageData["contentImage"];

			if (!contentHtml && !contentImage) {
				this._contentHtmlElement.innerHTML = "";
				this._contentImageElement.src = "";
				this._orignalContentContainerDisplayStyle = this._contentContainerElement.style.display;
				this._contentContainerElement.style.display = "none";
			}
			else {

				if (!contentHtml) {
					this._contentHtmlElement.innerHTML = "";
					this._contentHtmlElement.style.display = "none";
				}
				else {
					this._contentHtmlElement.innerHTML = contentHtml;
					this._contentHtmlElement.style.display = "block";
				}

				if (!contentImage) {
					this._contentImageElement.src = "";
					this._contentImageElement.style.display = "none";

					this._contentHtmlElement.style.textAlign = "center";
				}
				else {
					this._contentImageElement.src = contentImage;
					this._contentImageElement.style.display = "block";

					//this._contentHtmlElement.style.textAlign = "left";
				}

				this._contentContainerElement.style.display = this._orignalContentContainerDisplayStyle;
			}

			const footerText = this._pageData["footerText"];
			if (this._footerElement && this._footerTextElement) {
				if (footerText) {
					this._footerTextElement.innerText = footerText;
					this._footerElement.style.display = "block";
				}
				else {
					this._footerElement.style.display = "none";
				}
			}

			const navigationButtons = this._pageData["navigationButtons"];
			this._loadNavigationButtons(navigationButtons);
		}

		private _setNavigateBackVisibility(visible: boolean) {
			if (this._btnNavigateBack) {
				this._btnNavigateBack.style.opacity = visible ? "1" : "0";
				this._btnNavigateBack.style.pointerEvents = visible ? "initial" : "none";
			}
		}

		private _setNavigateNextVisibility(visible: boolean) {
			if (this._btnNavigateNext) {
				this._btnNavigateNext.style.opacity = visible ? "1" : "0";
				this._btnNavigateNext.style.pointerEvents = visible ? "initial" : "none";
			}
		}

		private _onHideHistoryButtonsChanged() {
			if (this._hideHistoryButtons) {
				if (this._btnNavigateBack) {
					this._btnNavigateBack.style.display = "none";
				}
				if (this._btnNavigateNext) {
					this._btnNavigateNext.style.display = "none";
				}
			}
			else {
				if (this._btnNavigateBack) {
					this._btnNavigateBack.style.display = "block";
				}
				if (this._btnNavigateNext) {
					this._btnNavigateNext.style.display = "block";
				}
			}
		}

		private _onHistoryChanged(history: NavigationHistory) {
			if (this._btnNavigateBack) {
				this._setNavigateBackVisibility(this._history.canGoBack);
			}
			if (this._btnNavigateNext) {
				this._setNavigateNextVisibility(this._history.canGoNext);
			}
		}

		private _onNavButtonClick(e: CustomEvent) {
			e.stopPropagation();

			if (this._isNavigating) {
				return;
			}
			this._isNavigating = true;

			const stepValues: DynamicObject = {};

			const navButton = e.detail.sender as WizardNavButton;
			for (const btn of this._navigationButtons) {
				if (btn !== navButton) {
					btn.isRejected = true;
				}
			}
			navButton.isSelected = true;

			for (const k of Object.keys(navButton.setters)) {
				stepValues[k] = navButton.setters[k];
			}
			if (e.detail.complete) {
				stepValues["completed"] = true;
				this._triggerWizardCompletedRequest(stepValues);
			}
			else {
				this._triggerNavigateRequest(e.detail.targetStep, stepValues);
			}
		}

		private _onBackButtonClick(e: Event) {
			e.stopPropagation();

			if (this._isNavigating) {
				return;
			}
			this._isNavigating = true;

			const navigateEvent = new CustomEvent(
				"navigate-back-request", {
					detail: {
						sender: this
					}
				});
			this.htmlElement.dispatchEvent(navigateEvent);
		}

		private _onNextButtonClick(e: Event) {
			e.stopPropagation();

			if (this._isNavigating) {
				return;
			}
			this._isNavigating = true;

			const navigateEvent = new CustomEvent(
				"navigate-next-request", {
					detail: {
						sender: this
					}
				});
			this.htmlElement.dispatchEvent(navigateEvent);
		}

		private _triggerNavigateRequest(pageKey: string, stepValues: DynamicObject) {
			const navigateEvent = new CustomEvent(
				"navigate-request", {
					detail: {
						sender: this,
						pageKey,
						stepValues
					}
				});
			this.htmlElement.dispatchEvent(navigateEvent);
		}

		private _triggerWizardCompletedRequest(stepValues: DynamicObject) {
			const completedEvent = new CustomEvent(
				"completed-request", {
					detail: {
						sender: this,
						stepValues
					}
				});
			this.htmlElement.dispatchEvent(completedEvent);
		}

		private _updateNavButtonsTemplate() {
			if (this._navButtonTemplate && this._navigationButtons) {
				for (const navButton of this._navigationButtons) {
					navButton.template = this._navButtonTemplate;
				}
			}
		}


		public get pageData() { return this._pageData; }
		public set pageData(v: WizardPageData) {
			this._pageData = v;
			this._loadPageData();
		}

		public get navButtonTemplate() { return this._navButtonTemplate; }
		public set navButtonTemplate(v: TemplateSource) {
			if (this._navButtonTemplate !== v) {
				this._navButtonTemplate = v;
				this._updateNavButtonsTemplate();
			}
		}

		get hideHistoryButtons() { return this._hideHistoryButtons; }
		set hideHistoryButtons(v) {
			if (this._hideHistoryButtons !== !!v) {
				this._hideHistoryButtons = !!v;
				this._onHideHistoryButtonsChanged();
			}
		}
	}
}